// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__LDkT5","content":"RecentSearches_content__1CCMP"};